import { render, staticRenderFns } from "./extendCascaderPannel.vue?vue&type=template&id=4d64e601&"
import script from "./extendCascaderPannel.vue?vue&type=script&lang=ts&"
export * from "./extendCascaderPannel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports